import { render } from "./New_McrForm.vue?vue&type=template&id=07c65dc4&scoped=true"
import script from "./New_McrForm.vue?vue&type=script&lang=js"
export * from "./New_McrForm.vue?vue&type=script&lang=js"

import "./New_McrForm.vue?vue&type=style&index=0&id=07c65dc4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07c65dc4"]])

export default __exports__